"use client"
import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import ProxyServer from './ProxyServer';
import Image from 'next/image';
import Sym from "../../../public/symantec.svg"
import Geo from "../../../public/geotrust.svg"
import Rap from "../../../public/rapidssl.svg"
import Com from "../../../public/comodo.svg"

const SslTabs = () => {
  return (
    <div className="custMargin">
      <div className="container">
        <div className="text-center">
          <h4 className="textHad fw-bold display-5">Temok SSL Products</h4>
          <p className="textPara fs-5 fw-normal">Expert Support, Flexible, Financially Wise.</p>
        </div>
        <Tabs defaultActiveKey="tab1" id="proxies-tabs" className="mb-3 border-0 justify-content-center">
          <Tab
            eventKey="tab1"
            title={
              <Image
                src={Sym}
                alt="Semi Dedicated Proxies"
                className="img-fluid" 
                width={100}
              />
            }
            className="sslTab"
          >
            <ProxyServer rawSlug="ssl" id="27,28,29,30,31,32,33,34" />
          </Tab>
          <Tab
            eventKey="tab2"
            title={
              <Image
                src={Geo}
                alt="Dedicated Proxies"
                className="img-fluid" 
                width={100}
              />
            }
            className="sslTab"
          >
            <ProxyServer rawSlug="ssl" id="19,20,21,22,23,24,25,26" />
          </Tab>
          <Tab
            eventKey="tab3"
            title={
              <Image
                src={Rap}
                alt="Dedicated Proxies"
                className="img-fluid" 
                width={100}
              />
            }
            className="sslTab"
          >
            <ProxyServer rawSlug="ssl" id="16,17,18" />
          </Tab>
          <Tab
            eventKey="tab4"
            title={
              <Image
                src={Com}
                alt="Dedicated Proxies"
                className="img-fluid" 
                width={100}
              />
            }
            className="sslTab"
          >
            <ProxyServer rawSlug="ssl" id="42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69" />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default SslTabs;
